import React, { FC } from 'react'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import CustomFormProfessionalContractTypeSelectionDrawerManagerContent from './Content'
import CustomFormProfessionalContractTypeSelectionDrawerManagerProvider from './contexts/CustomFormProfessionalContractTypeSelectionDrawerManager/Provider'

type Props = {
  question: CustomFormQuestion
  questionKey: string
  disabled?: boolean
}

const CustomFormProfessionalContractTypeSelectionDrawer: FC<Props> = ({ question, questionKey, disabled }) => {
  return (
    <CustomFormProfessionalContractTypeSelectionDrawerManagerProvider questionKey={questionKey}>
      <CustomFormProfessionalContractTypeSelectionDrawerManagerContent question={question} disabled={disabled} />
    </CustomFormProfessionalContractTypeSelectionDrawerManagerProvider>
  )
}

export default CustomFormProfessionalContractTypeSelectionDrawer
